// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/footer-logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <WhatsAppIcon />,
      link: "https://wa.me/250795305418",
    },
    {
      icon: <FacebookIcon />,
      link: "#",
    },
    {
      icon: <InstagramIcon />,
      link: "#",
    },
  ],
  menus: [
    {
      name: "company",
      items: [
        { name: "Home page", href: "/" },
        { name: "About us", href: "/about" },
      ],
    },
    {
      name: "resources",
      items: [
        { name: "Booking", href: "/booking" },
        { name: "Contact us", href: "/contact" },
      ],
    },
    {
      name: "help & support",
      items: [
        { name: "Contact us", href: "/contact" },
        { name: "About us", href: "/about" },
      ],
    },
    {
      name: "legal",
      items: [
        { name: "Terms & Conditions", href: "/terms-condtions" },
        { name: "Privacy Policy", href: "/privacy-policy" },
        { name: "Disclaimer", href: "/disclaimer" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      &copy; {date} Helper Everywhere | All rights reserved.
    </MKTypography>
  ),
};
